import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import PropTypes from 'prop-types';
import GridAreaContainer from '@sprinx/react-mui-components/GridAreaContainer';
import ProductDetailLink from '../ProductDetailLink';

function ProductListItemDetailLink(_ref) {
  var children = _ref.children,
      href = _ref.href,
      ProductDetailLinkProps = _ref.ProductDetailLinkProps,
      renderToGridArea = _ref.renderToGridArea,
      rest = _objectWithoutProperties(_ref, ["children", "href", "ProductDetailLinkProps", "renderToGridArea"]);

  return /*#__PURE__*/React.createElement(GridAreaContainer, _extends({
    renderToGridArea: renderToGridArea
  }, rest), /*#__PURE__*/React.createElement(ProductDetailLink, _extends({
    href: href
  }, ProductDetailLinkProps), children));
}

ProductListItemDetailLink.propTypes = {
  children: PropTypes.node,
  href: PropTypes.string,
  ProductDetailLinkProps: PropTypes.shape({}),
  renderToGridArea: PropTypes.string
};
ProductListItemDetailLink.defaultProps = {
  children: undefined,
  href: undefined,
  ProductDetailLinkProps: undefined,
  renderToGridArea: 'name'
};
export default ProductListItemDetailLink;